<mat-card [ngStyle]="{width:width,padding:padding}" style="max-width: 100%">
  <mat-card-header>
    @if (title.length>0) {
      <mat-card-title>
        {{title}}
      </mat-card-title>
    }
    @if (subtitle.length>0) {
      <mat-card-subtitle>
        {{subtitle}}
      </mat-card-subtitle>
    }
  </mat-card-header>
  <mat-card-content>
    <ng-content>

    </ng-content>
  </mat-card-content>
</mat-card>
